/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestGetUserSearchOptionsRequest
 */
export interface RequestGetUserSearchOptionsRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestGetUserSearchOptionsRequest
     */
    baseId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetUserSearchOptionsRequest
     */
    permissionId: number;
    /**
     * 必須
     * @type {number}
     * @memberof RequestGetUserSearchOptionsRequest
     */
    tenantId: number;
}

/**
 * Check if a given object implements the RequestGetUserSearchOptionsRequest interface.
 */
export function instanceOfRequestGetUserSearchOptionsRequest(value: object): value is RequestGetUserSearchOptionsRequest {
    if (!('baseId' in value) || value['baseId'] === undefined) return false;
    if (!('permissionId' in value) || value['permissionId'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    return true;
}

export function RequestGetUserSearchOptionsRequestFromJSON(json: any): RequestGetUserSearchOptionsRequest {
    return RequestGetUserSearchOptionsRequestFromJSONTyped(json, false);
}

export function RequestGetUserSearchOptionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestGetUserSearchOptionsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'],
        'permissionId': json['permission_id'],
        'tenantId': json['tenant_id'],
    };
}

export function RequestGetUserSearchOptionsRequestToJSON(json: any): RequestGetUserSearchOptionsRequest {
    return RequestGetUserSearchOptionsRequestToJSONTyped(json, false);
}

export function RequestGetUserSearchOptionsRequestToJSONTyped(value?: RequestGetUserSearchOptionsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'permission_id': value['permissionId'],
        'tenant_id': value['tenantId'],
    };
}

